import type { DataQueryResponse, DataRow, VisualizationType, WidgetDefinition } from './types';

export const SNAPSHOT_VISUALIZATIONS = new Set<VisualizationType>([
  'kpi',
  'pie',
  'histogram',
  'population_pyramid',
  'choropleth',
  'map_symbols',
  'flow_map',
  'district_mini_maps',
]);

export function isSnapshotVisualization(visualization: VisualizationType): boolean {
  return SNAPSHOT_VISUALIZATIONS.has(visualization);
}

export function periodsInData(data: DataQueryResponse): string[] {
  return [...new Set(data.rows.map((row) => row.period))].sort((a, b) => a.localeCompare(b, 'ru'));
}

export function selectedPeriod(widget: WidgetDefinition, data: DataQueryResponse): string | null {
  const periods = periodsInData(data);
  if (!periods.length) return null;
  return widget.time.activePeriod && periods.includes(widget.time.activePeriod)
    ? widget.time.activePeriod
    : periods.at(-1) ?? null;
}

export function rowsForPeriod(data: DataQueryResponse, period: string | null): DataRow[] {
  if (!period) return [];
  return data.rows.filter((row) => row.period === period);
}

export function finiteValues(rows: DataRow[]): number[] {
  return rows
    .map((row) => row.value)
    .filter((value): value is number => value != null && Number.isFinite(value));
}

export function previousPeriod(periods: string[], activePeriod: string): string | null {
  const index = periods.indexOf(activePeriod);
  return index > 0 ? periods[index - 1] ?? null : null;
}
